(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth','$uibModalInstance','$rootScope'];

    function RequestResetController ($timeout, Auth,$uibModalInstance,$rootScope) {
        var vm = this;
        vm.publicKey = "6LfItR0UAAAAAI7yY9TTAp2mC40kVepEHrK77fpF";
        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;
        vm.clear=clear;
        //$rootScope.navbar=false;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        $timeout(function (){angular.element('#email').focus();});
      
        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;
              
             Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
            	vm.errorEmailNotExists =null;
            	  vm.errorEmailNotAllowed =null;
            	  vm.error =null;
                vm.success = 'OK';
            })["catch"](function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                	  vm.errorEmailNotAllowed =null;
                    vm.errorEmailNotExists = 'ERROR';
                }else if(response.status === 400 && response.data === 'e-mail address not allowed') {
                	vm.errorEmailNotExists =null;
                    vm.errorEmailNotAllowed = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
        
        vm.setRecaptchaId = setRecaptchaId;
        function setRecaptchaId(widgetId) {
			vm.recaptchaId = widgetId;
			if (vm.recaptchaId == 0) {
				vm.captcha = false;
			} else {
				vm.captcha = true;
			}
		}
    }
})();
